export const BASE_URL = 'positions';

export const PATHS = {
  BASE_URL,
  CREATE_POSITION: `${BASE_URL}/create`,
};

export const goTocreateJob = () => PATHS.CREATE_POSITION;

export const FORMS = {
  position: 'position',
};
